<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>
    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Servicios</h1>
    </div>
  </div>

  <div class="row-cols-12 m-2 mt-0">
    <div class="row p-0 p-md-3 mb-0 align-items-center">
      <div class="mb-3 mt-0 text-start">
        @if (error(); as err) {
          @if (err.length > 0) {
            <div class="alert alert-danger mt-0" role="alert">
              <small>{{ err }}</small>
            </div>
          }
        }

        @if (message(); as msg) {
          @if (msg.length > 0) {
            <div class="alert alert-success mt-0" role="alert">
              <small>{{ msg }}</small>
            </div>
          }
        }

        <div class="d-grid mt-0 mb-3 pb-3">
          <button
            type="button"
            class="btn btn-primary btn-lg mt-0"
            [routerLink]="['/my-account-servicio']"
          >
            Agregar nuevo servicio
          </button>
        </div>

        <span class="p-0 m-0">
          <b>Servicios cargados ({{ servicios().length }})</b>
        </span>

        @for (servicio of servicios(); track servicio.id) {
          <div class="servicio-card mt-3 form-switch">
            <a
              class="text-decoration-none text-dark flex-grow-1 overflow-hidden"
              [routerLink]="['/my-account-edit-servicio/' + servicio.id]"
            >
              <div class="servicio-title text-truncate">
                {{ servicio.descripcionPrestacion }}
              </div>

              <div class="servicio-subtitle text-truncate">
                {{ servicio.descripcionEspecialidad }}
              </div>

              @if (servicio.x_descripcion) {
                <div class="servicio-extra text-truncate">
                  {{ servicio.x_descripcion }}
                </div>
              }
            </a>

            <div class="col-2">
              <a
                class="servicio-action"
                [routerLink]="['/my-account-edit-servicio/' + servicio.id]"
              >
                <i class="bi bi-pencil"></i>
              </a>
            </div>

            <div class="col-auto">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="servicio.b_activo"
                (change)="activarDesactivar(servicio, $any($event.target).checked)"
                [disabled]="loading()"
              />
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
